import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * Shared toast-style alerts (Material snack bar) for API failures and confirmations app-wide.
 */
@Injectable({ providedIn: 'root' })
export class UiAlertService {
  private readonly snackBar = inject(MatSnackBar);

  showError(message: string, durationMs = 8000): void {
    const msg = message?.trim() || 'Something went wrong.';
    this.snackBar.open(msg, 'Dismiss', {
      duration: durationMs,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: ['app-snackbar', 'app-snackbar-error'],
    });
  }

  showSuccess(message: string, durationMs = 4500): void {
    const msg = message?.trim() || 'Done.';
    this.snackBar.open(msg, 'Dismiss', {
      duration: durationMs,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: ['app-snackbar', 'app-snackbar-success'],
    });
  }
}
